import { chainName } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldSelect, FormField } from 'components/formKit'
import { t } from 'services/Translation'

import type { CourseProgressValueFormType } from './courseProgressTypes'

const PERCENT_POSITION = genElementValueField({
  as: FieldSelect<'left' | 'right' | 'hide'>,
  name: 'percentPosition',
  label: t('input.label.value'),
  defaultValue: 'right',
  props: {
    fluid: true,
    options: [
      { value: 'left', label: t('input.option.left') },
      { value: 'right', label: t('input.option.right') },
      { value: 'hide', label: t('input.option.hide') },
    ],
  },
})

const CourseProgressForm: CourseProgressValueFormType = ({ name }) => {
  return (
    <Padding bottom gap sides>
      <FormField config={chainName(name, PERCENT_POSITION)} />
    </Padding>
  )
}

export default CourseProgressForm
